import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

function EditPost() {

  const { id } = useParams();

  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [slug, setSlug] = useState("");
  const [excerpt, setExcerpt] = useState("");
  const [category, setCategory] = useState("");
  const [content, setContent] = useState("");
  const [status, setStatus] = useState("Published");

  // FETCH SINGLE POST
  const getPost = async () => {

    try {

      const res = await axios.get(
        `http://localhost:5000/api/posts/${id}`
      );

      const post = res.data;

      setTitle(post.title);
      setSlug(post.slug);
      setExcerpt(post.excerpt);
      setCategory(post.category);
      setContent(post.content);
      setStatus(post.status);

    } catch (err) {

      console.log(err);

    }

  };

  // UPDATE POST
  const handleUpdate = async () => {

    try {

      await axios.put(
        `http://localhost:5000/api/posts/${id}`,
        {
          title,
          slug,
          excerpt,
          category,
          content,
          status,
        }
      );

      alert("Post updated successfully");

      navigate("/admin/posts");

    } catch (err) {

      console.log(err);

      alert("Failed to update post");

    }

  };

  useEffect(() => {

    getPost();

  }, []);

  return (
    <section className="min-h-screen bg-[#F5F7FA] p-8 md:p-14">

      {/* HEADER */}
      <div className="mb-12">

        <p className="uppercase tracking-[5px] text-yellow-600 font-semibold text-sm mb-3">
          Admin Panel
        </p>

        <h1 className="text-5xl font-bold text-[#0B1C39]">
          Edit Post
        </h1>

      </div>

      {/* FORM */}
      <div className="bg-white rounded-[32px] shadow-xl p-8 md:p-12 border border-gray-100">

        {/* TITLE */}
        <div className="mb-8">

          <label className="block font-semibold mb-3">
            Title
          </label>

          <input
            type="text"
            className="w-full border border-gray-300 rounded-2xl px-5 py-4"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />

        </div>

        {/* SLUG */}
        <div className="mb-8">

          <label className="block font-semibold mb-3">
            Slug
          </label>

          <input
            type="text"
            className="w-full border border-gray-300 rounded-2xl px-5 py-4"
            value={slug}
            onChange={(e) => setSlug(e.target.value)}
          />

        </div>

        {/* EXCERPT */}
        <div className="mb-8">

          <label className="block font-semibold mb-3">
            Excerpt
          </label>

          <textarea
            rows="4"
            className="w-full border border-gray-300 rounded-2xl px-5 py-4"
            value={excerpt}
            onChange={(e) => setExcerpt(e.target.value)}
          />

        </div>

        {/* CATEGORY */}
        <div className="mb-8">

          <label className="block font-semibold mb-3">
            Category
          </label>

          <select
            className="w-full border border-gray-300 rounded-2xl px-5 py-4"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >

            <option value="Blog">
              Blog
            </option>

            <option value="Legal Guide">
              Legal Guide
            </option>

            <option value="Legal Update">
              Legal Update
            </option>

            <option value="FAQ">
              FAQ
            </option>

            <option value="Case Study">
              Case Study
            </option>

          </select>

        </div>

        {/* STATUS */}
        <div className="mb-8">

          <label className="block font-semibold mb-3">
            Status
          </label>

          <select
            className="w-full border border-gray-300 rounded-2xl px-5 py-4"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
          >

            <option value="Published">
              Published
            </option>

            <option value="Draft">
              Draft
            </option>

          </select>

        </div>

        {/* CONTENT */}
        <div className="mb-10">

          <label className="block font-semibold mb-3">
            Content
          </label>

          <ReactQuill
            theme="snow"
            value={content}
            onChange={setContent}
            className="h-[400px] mb-16"
          />

        </div>

        {/* BUTTON */}
        <button
          onClick={handleUpdate}
          className="bg-[#0B3D91] text-white px-8 py-4 rounded-2xl font-semibold hover:bg-[#082b67]"
        >
          Update Post
        </button>

      </div>

    </section>
  );
}

export default EditPost;